import { catalogSearchConstants } from '../constants'

const initialState = {
    search: '',
    contentType: '',
    language: '',
    sortBy: '',
    integratedOnly: false,
}

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case catalogSearchConstants.CHANGE:
            return {
                ...state,
                ...action.params,
            }
        case catalogSearchConstants.RESET:
            return {
                ...initialState,
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/reducers/catalogSearch.js